import { GetValueCompanyTrackingContentPackageMeta, GetValueCompanyTrackingContentPackagePayload } from 'types/store/GetValueCompanyTrackingContentPackage';
import { createAsyncReducer } from 'utils/Redux';

import { getValueCompanyTrackingContentPackageActions } from '../actions';

export default createAsyncReducer<GetValueCompanyTrackingContentPackageMeta, GetValueCompanyTrackingContentPackagePayload>(getValueCompanyTrackingContentPackageActions);
